import { create } from 'zustand';

interface ModalStore {
  modalOpen: boolean;
  bulkUpload?: boolean;
}

let settings: ModalStore = {
  modalOpen: false,
  bulkUpload: false
};

export interface ModalState {
  actions: {
    setModal: (settings: ModalStore) => void;
    setBulkUpload: (bulkUpload: boolean) => void;
  };
  settings: ModalStore;
}

export const useModalStore = create<ModalState>((set) => ({
  settings,
  actions: {
    setModal: (settings: ModalStore) => {
      // @ts-ignore
      set((state) => ({
        settings: { ...state.settings, ...settings }
      }));
    },
    setBulkUpload: (bulkUpload: boolean) => {
      set((state) => ({
        settings: { ...state.settings, bulkUpload }
      }));
    }
  }
}));
